import { observer } from "mobx-react-lite";
import styles from "./Login.module.css";
import { LoginBox } from "./LoginBox";
import { userStore } from "@/stores/UserStore";
import { authStore } from "@/stores/AuthStore";
import { frameAnimation, GridPoint } from "./frameAnimation";
import React, { useEffect, useRef, useState } from "react";

export const Login = observer(() => {
  const refLogin = useRef(null);
  const refLoginBox = useRef(null);
  const refFrame = useRef(null);
  const [frameAnim, setFrameAnim] = useState<GridPoint[]>([]);
  const lastStepRef = useRef<GridPoint | null>(null);

  const getNextStep = () => {
    if (!frameAnim.length) return null;

    let next = frameAnim[Math.floor(Math.random() * frameAnim.length)];

    if (frameAnim.length > 1 && lastStepRef.current) {
      let attempts = 0;

      while (next.x === lastStepRef.current.x && next.y === lastStepRef.current.y && attempts < 10) {
        next = frameAnim[Math.floor(Math.random() * frameAnim.length)];
        attempts++;
      }
    }

    lastStepRef.current = next;
    return next;
  };

  useEffect(() => {
    let timeOut: NodeJS.Timeout;
    if (refFrame.current && frameAnim.length) {
      const el = refFrame.current as HTMLElement;
      timeOut = setTimeout(() => {
        el.classList.add(styles.view);
        el.classList.add(styles.start);
      }, 3000);

      const step = getNextStep();
      if (step) {
        el.style.transition = "none";
        el.style.setProperty("--target-x", `${step.x}px`);
        el.style.setProperty("--target-y", `${step.y}px`);
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            el.style.transition = "transform 1s linear";
          });
        });
      }
    }

    return () => {
      clearTimeout(timeOut);
    };
  }, [frameAnim]);

  useEffect(() => {
    if (!refLogin.current || !refLoginBox.current) return;
    setFrameAnim(frameAnimation(refLogin.current, refLoginBox.current));
  }, []);

  console.log("render Login");

  const endAnim = (e: React.AnimationEvent) => {
    if (!refFrame.current) return;
    const el = refFrame.current as HTMLElement;

    if (e.animationName.includes("goStart")) {
      el.classList.remove(styles.start);
      void el.offsetWidth;

      const step = getNextStep();
      if (step) {
        el.style.setProperty("--target-x", `${step.x}px`);
        el.style.setProperty("--target-y", `${step.y}px`);
      }
    }
  };

  const endTrans = (e: React.TransitionEvent) => {
    if (e.propertyName === "transform") {
      if (!refFrame.current) return;
      const el = refFrame.current as HTMLElement;
      el.classList.add(styles.start);
    }
  };

  if (authStore.isLoading) {
    return;
  }

  if (userStore.isAuthenticated) {
    return;
  }

  return (
    <div className={styles.login} ref={refLogin}>
      <LoginBox ref={refLoginBox} />
      <div className={styles.bg}>
        <div>
          <div ref={refFrame} onAnimationEnd={endAnim} onTransitionEnd={endTrans} className={styles.frame}>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
});
